import { render } from "./CollectionDetail.vue?vue&type=template&id=63d87ac0&scoped=true&ts=true"
import script from "./CollectionDetail.vue?vue&type=script&lang=ts"
export * from "./CollectionDetail.vue?vue&type=script&lang=ts"

import "./CollectionDetail.vue?vue&type=style&index=0&id=63d87ac0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d87ac0"]])

export default __exports__